export default "__VITE_ASSET__CFB2uiXr__"